export default {"src":"/_next/static/media/visa.6e0a45bf.svg","height":24,"width":34,"blurWidth":0,"blurHeight":0};